import { Action_SetCurrentSection,
         Action_SetCurrentApplication,
         Action_StudentValidationForNewApplication,
         Action_StoreStudentDetails,
         Action_ClearStudentDetails,
         Action_ApplicationSectionSaved,
         Action_ApplicationProgramChanged} from './actions';

export function ApplicationReducer(state, action) {
    switch (action.type) {
        case Action_SetCurrentSection:
            return {
                ...state,
                currentSection: action.payload
            };
        case Action_SetCurrentApplication:
            return {
                ...state,
                currentApplicationId: action.payload
            };
        case Action_StudentValidationForNewApplication:
            return {
                ...state,
                studentValidationDetails: action.payload
            };
        case Action_StoreStudentDetails:
            return {
                ...state,
                studentDetails: action.payload
            };
        case Action_ClearStudentDetails:
            return {
                ...state,
                studentDetails: null
            };
        case Action_ApplicationSectionSaved:
            return {
                ...state,
                applicationSectionSaved: true
            };
        case Action_ApplicationProgramChanged:
            return {
                ...state,
                schoolProgramChanged: true
            };
    default:
        return state;
    }
}


